import {
	TIDSelectedTypeFirmware,
	TActiveItemToDisplay,
	TTypeOfModalWindow,
	IIDsSelectedItems,
	IFirmwareWithAdditionalProperty,
} from './firmwareAssignmentContext';
import {
	IFirmwareForAssign,
	IDataGetRestaurantsByIDsCustomersForFirmware,
	IDataGetCustomersForAssignFirmware,
} from 'types';

export enum FirmwareAssignmentActionTypes {
	SET_FIRMWARE_FOR_ASSIGN = 'SET_FIRMWARE_FOR_ASSIGN',
	CHANGE_SEARCH_STRING = 'CHANGE_SEARCH_STRING',
	CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS = 'CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS',
	CHANGE_SEARCH_STRING_FOR_RESTAURANTS = 'CHANGE_SEARCH_STRING_FOR_RESTAURANTS',
	CHANGE_SEARCH_STRING_FOR_FIRMWARES = 'CHANGE_SEARCH_STRING_FOR_FIRMWARES',
	CHANGE_TYPE_FIRMWARE = 'CHANGE_TYPE_FIRMWARE',
	RESET_SELECTED_CONTROLS = 'RESET_SELECTED_CONTROLS',
	CHANGE_UNASSIGNED_FIRMWARE_STATUS = 'CHANGE_UNASSIGNED_FIRMWARE_STATUS',
	SET_IDS_SELECTED_FIRMWARE = 'SET_IDS_SELECTED_FIRMWARE',
	CHANGE_ACTIVE_ITEM_TO_DISPLAY = 'CHANGE_ACTIVE_ITEM_TO_DISPLAY',
	SET_SHOW_BREADCRUMBS = 'SET_SHOW_BREADCRUMBS',
	SET_ALL_CUSTOMERS = 'SET_ALL_CUSTOMERS',
	SET_IDS_SELECTED_CUSTOMERS = 'SET_IDS_SELECTED_CUSTOMERS',
	SET_IDS_SELECTED_RESTAURANTS = 'SET_IDS_SELECTED_RESTAURANTS',
	SET_FIRMWARES = 'SET_FIRMWARES',
	CHANGE_TYPE_OF_MODAL_WINDOW = 'CHANGE_TYPE_OF_MODAL_WINDOW',
	CHANGE_CURRENT_PAGE = 'CHANGE_CURRENT_PAGE',
	RESET_CHANGES = 'RESET_CHANGES',
}

interface ISetFirmwareForAssign {
	type: FirmwareAssignmentActionTypes.SET_FIRMWARE_FOR_ASSIGN;
	payload: {
		firmwareForAssign: IFirmwareForAssign;
	};
}

interface IChangeSearchString {
	type: FirmwareAssignmentActionTypes.CHANGE_SEARCH_STRING;
	payload: {
		searchString: string;
	};
}

interface IChangeSearchStringForAllCustomers {
	type: FirmwareAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS;
	payload: {
		searchStringForAllCustomers: string;
	};
}

interface IChangeSearchStringForRestaurants {
	type: FirmwareAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_RESTAURANTS;
	payload: {
		searchStringForRestaurants: string;
	};
}

interface IChangeSearchStringForFirmwares {
	type: FirmwareAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_FIRMWARES;
	payload: {
		searchStringForFirmwares: string;
	};
}

interface IChangeTypeFirmware {
	type: FirmwareAssignmentActionTypes.CHANGE_TYPE_FIRMWARE;
	payload: {
		IDSelectedTypeFirmware: TIDSelectedTypeFirmware;
	};
}

interface IResetSelectedControls {
	type: FirmwareAssignmentActionTypes.RESET_SELECTED_CONTROLS;
}

interface IChangeIsUnassignedFirmwareStatus {
	type: FirmwareAssignmentActionTypes.CHANGE_UNASSIGNED_FIRMWARE_STATUS;
	payload: {
		isUnassignedFirmware: boolean;
	};
}

interface ISetIDsSelectedFirmware {
	type: FirmwareAssignmentActionTypes.SET_IDS_SELECTED_FIRMWARE;
	payload: {
		IDsSelectedFirmware: string[];
	};
}

interface IChangeActiveItemToDisplay {
	type: FirmwareAssignmentActionTypes.CHANGE_ACTIVE_ITEM_TO_DISPLAY;
	payload: {
		activeItemToDisplay: TActiveItemToDisplay;
	};
}

interface ISetShowBreadcrumbs {
	type: FirmwareAssignmentActionTypes.SET_SHOW_BREADCRUMBS;
	payload: {
		isShowBreadcrumbs: boolean;
	};
}

interface ISetAllCustomers {
	type: FirmwareAssignmentActionTypes.SET_ALL_CUSTOMERS;
	payload: {
		allCustomers: IDataGetCustomersForAssignFirmware[];
	};
}

interface ISetIDsSelectedCustomers {
	type: FirmwareAssignmentActionTypes.SET_IDS_SELECTED_CUSTOMERS;
	payload: {
		IDsSelectedCustomers: IIDsSelectedItems;
		restaurants: IDataGetRestaurantsByIDsCustomersForFirmware[];
		IDsSelectedRestaurants: IIDsSelectedItems;
		firmwares: IFirmwareWithAdditionalProperty[];
	};
}

interface ISetIDsSelectedRestaurants {
	type: FirmwareAssignmentActionTypes.SET_IDS_SELECTED_RESTAURANTS;
	payload: {
		IDsSelectedRestaurants: IIDsSelectedItems;
		firmwares: IFirmwareWithAdditionalProperty[];
	};
}

interface ISetFirmwares {
	type: FirmwareAssignmentActionTypes.SET_FIRMWARES;
	payload: {
		firmwares: IFirmwareWithAdditionalProperty[];
		IDsSelectedFirmware: string[];
	};
}

interface IChangeTypeOfModalWindow {
	type: FirmwareAssignmentActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW;
	payload: {
		typeOfModalWindow: TTypeOfModalWindow;
	};
}

interface IChangeCurrentPage {
	type: FirmwareAssignmentActionTypes.CHANGE_CURRENT_PAGE;
	payload: {
		currentPage: number;
	};
}

interface IResetChanges {
	type: FirmwareAssignmentActionTypes.RESET_CHANGES;
}

export type TFirmwareAssignmentAction =
	| ISetFirmwareForAssign
	| IChangeSearchString
	| IChangeSearchStringForAllCustomers
	| IChangeSearchStringForRestaurants
	| IChangeSearchStringForFirmwares
	| IChangeTypeFirmware
	| IResetSelectedControls
	| IChangeIsUnassignedFirmwareStatus
	| ISetIDsSelectedFirmware
	| IChangeActiveItemToDisplay
	| ISetShowBreadcrumbs
	| ISetAllCustomers
	| ISetIDsSelectedCustomers
	| ISetIDsSelectedRestaurants
	| ISetFirmwares
	| IChangeTypeOfModalWindow
	| IChangeCurrentPage
	| IResetChanges;
